module.exports = __webpack_public_path__ + "static/img/hyper-tube-wall-support_256.144cfc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-wall-support_256.png
// module id = LpSn
// module chunks = 0